import { AI_FILE_EXTENSIONS, RECENT_RESPONDENT_DOCUMENTS_QUERY, } from "../constants/ai.js";
import { fileExtension } from "./string.js";
/** How many of a respondent's newest documents the case file manifest lists. */
export const AI_CASE_FILE_DOCUMENT_LIMIT = 50;
export const AI_DOCUMENT_LEFT_OUT_REASONS = {
    unsupported: "a file type the AI cannot read",
    tooLarge: `over ${RECENT_RESPONDENT_DOCUMENTS_QUERY.maxFileSize / 1024 / 1024} MB or of unknown size`,
    notRecent: `not among the ${RECENT_RESPONDENT_DOCUMENTS_QUERY.pageSize} most recent documents`,
    notSelected: "not selected as context",
    unreadable: "could not be read",
};
/**
 * Why a respondent document was not given to the AI, or null when it was.
 * Mirrors the recent documents query. Ids are compared as strings.
 */
export const aiDocumentLeftOutReason = (document, { attachedIds, unreadableIds = new Set(), recentDocuments, }) => {
    const id = String(document.id);
    if (unreadableIds.has(id))
        return "unreadable";
    if (attachedIds.has(id))
        return null;
    if (!AI_FILE_EXTENSIONS.includes(fileExtension(document.fileName)))
        return "unsupported";
    if (!document.fileSize ||
        document.fileSize > RECENT_RESPONDENT_DOCUMENTS_QUERY.maxFileSize)
        return "tooLarge";
    return recentDocuments ? "notRecent" : "notSelected";
};
//# sourceMappingURL=aiDocuments.js.map